'use strict';

import Backbone from 'backbone';
import config from '../../js/config';
import * as BomService from '../../services/BomService';
import * as CsrfService from '../../services/CsrfService';
import templateBomModalControls from './templates/BomModalControls.hbs';


export default class BomModalControls extends Backbone.View {
  get events() {
    return {
      'click .BomModal-buttons-add': 'handleBomAdd',
      'click .BomModal-buttons-retry': 'handleBomRetry',
      'click .BomModal-buttons-goToBom': 'handleGoToBom'
    };
  }

  initialize() {
    this.listenTo(this.collection, 'change:selected', this.handleBomSelectionChanged);
  }

  initializeElements() {
    this.$addButton = this.$('.BomModal-buttons-add');
    this.$actionButton = this.$('.BomModal-buttons-add, .BomModal-buttons-retry');
  }

  reInitialize() {
    if (this.$bomModalElements) {
      this.$firstElement = this.$bomModalElements.find('#bom-modal-close');
      this.$lastElement = this.$bomModalElements.find('#bom-modal-cancel');
      this.disabledButtonId = '#BomModal-buttons-goToBom';
      this.$disabledButton = this.$bomModalElements.find(this.disabledButtonId);
      this.$firstElement.on('keydown',(e)=>{
        if (e.key === 'Tab' && e.shiftKey) {
          e.preventDefault();
          if (this.$disabledButton.attr('disabled')) {
            this.$lastElement.focus();
          }
          else {
            this.$disabledButton.focus();
          }
        }
      });
      this.$lastElement.on('keydown', (e)=>{
        if (e.key === 'Tab' && !e.shiftKey) {
          e.preventDefault();
          if (this.$disabledButton.attr('disabled')) {
            this.$firstElement.focus();
          }
          else {
            this.$disabledButton.focus();
          }
        }
      });
      this.$disabledButton.on('keydown', (e)=>{
        if (e.key === 'Tab' && !e.shiftKey) {
          e.preventDefault();
          this.$firstElement.focus();
        }
      });
    }
  }

  handleBomSelectionChanged() {
    let selected = this.collection.filter(modal => modal.get('selected'));

    // If all selected are successes then display Done button
    if (selected.length && selected.every(model => model.get('success'))) {
      this.render('done');
      this.reInitialize();
      return;
    }

    // If all selected are successes/retry then display Retry buttons
    if (selected.length && selected.every(model => model.get('failed') || model.get('success'))) {
      this.render('retry');
      this.reInitialize();
      return;
    }

    // Display add button
    this.render('add');

    // Disable add button if nothing is selected
    this.$addButton.prop('disabled', !selected.length);
    this.reInitialize();
  }

  handleBomAdd() {
    let selectedBoms = this.collection.filter(model => model.get('selected'));

    if (!selectedBoms.length) {
      return;
    }

    this.addPartToSelectedBoms(selectedBoms);
  }

  handleBomRetry() {
    let selectedBoms = this.collection.filter(model => model.get('selected'));
    let failedBoms = selectedBoms.filter(model => model.get('failed'));

    if (!failedBoms.length) {
      return;
    }

    this.addPartToSelectedBoms(failedBoms);
  }

  addPartToSelectedBoms(selectedBoms) {
    this.setLoading();

    let allRequests = selectedBoms.map(model => this.addPartToBom(model));

    // When all requests have finished
    return Promise.all(allRequests).then(() => {
      this.setLoaded();
      this.handleBomSelectionChanged();
    });
  }

  addPartToBom(model) {
    this.handlePartAddingToBom(model);

    return new Promise(resolve => {
      let bomId = model.get('bomId');

      CsrfService.getToken().then(csrfToken => {
        BomService.addPartToBom(bomId, this.partNumber, this.manufacturerName, csrfToken, Math.abs(parseInt(this.quantity, 10) || 1))
          .then(() => {
            this.handlePartAddToBomSuccess(model);
            resolve({ success: true, bomId });
          })
          .catch(() => {
            this.handlePartAddToBomFailed(model);
            resolve({ success: false, bomId });
          })
      });
    });
  }

  handlePartAddingToBom(model) {
    model.set({ loading: true, success: false, failed: false });
  }

  handlePartAddToBomSuccess(model) {
    model.set({ loading: false, success: true, failed: false });
  }

  handlePartAddToBomFailed(model) {
    model.set({ loading: false, success: false, failed: true });
  }

  handleGoToBom() {
    let selectedBoms = this.collection.filter(model => model.get('selected'));

    let url = config.urls.bomTool;

    if (window.location.hostname.indexOf('.com') !== -1) {
      url = '/' + config.languages.english + url;
    }

    if (selectedBoms.length === 1) {
      url += `/view/${selectedBoms[0].get('bomId')}/1`;
    }

    document.location.assign(url);
  }

  /**
   * Add loading status
   */
  setLoading() {
    this.$actionButton.prop('disabled', true);
    this.$el.addClass(config.classes.loadingClass);
  }

  /**
   * Remove loading status
   */
  setLoaded() {
    this.$actionButton.prop('disabled', false);
    this.$el.removeClass(config.classes.loadingClass);
  }

  render(mode = 'add') {
    this.$el.html(templateBomModalControls({
      bomList: this.collection.toJSON(),
      mode
    }));

    this.initializeElements();
  }
};



// WEBPACK FOOTER //
// ./assets/components/BomModal/BomModalControls.js